module.exports = __webpack_public_path__ + "img/maze_square_c.1bda5388.svg";